<div class="modal" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<div class="form-floating mb-3">
					<input
						type="text"
						class="form-control"
						id="name"
						name="number"
						[(ngModel)]="data.number"
						required
					/>
					<label for="number">Numer karty</label>
				</div>
				<div class="form-floating">
					<textarea
						class="form-control"
						id="comments"
						style="height: 100px"
						name="comments"
						[(ngModel)]="data.comments"
					></textarea>
					<label for="comments">Komentarz</label>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="submit()">Zapisz</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogClose()">
					Anuluj
				</button>
			</div>
		</div>
	</div>
</div>
